const trans_enrich_path_kegg = {
    "CA12DAP_vs_CA9DAP": 
        
         [
            "/api/static/expression/enrich/CA12DAP_vs_CA9DAP_KEGG_barplot.png"
        ],
  
    "CA15DAP_vs_CA12DAP": 
        
         [
            "/api/static/expression/enrich/CA15DAP_vs_CA12DAP_KEGG_barplot.png"
        ],
  
    "CA15DAP_vs_CA9DAP": 
        
         [
            "/api/static/expression/enrich/CA15DAP_vs_CA9DAP_KEGG_barplot.png"
        ],
  
    "DAP12_vs_DAP15": 
        
         [
            "/api/static/expression/enrich/DAP12_vs_DAP15_KEGG_barplot.png"
        ],
  
    "DAP12_vs_DAP18": 
        
         [
            "/api/static/expression/enrich/DAP12_vs_DAP18_KEGG_barplot.png"
        ],
  
    "DAP12_vs_DAP21": 
        
         [
            "/api/static/expression/enrich/DAP12_vs_DAP21_KEGG_barplot.png"
        ],
  
    "DAP12_vs_DAP24": 
        
         [
            "/api/static/expression/enrich/DAP12_vs_DAP24_KEGG_barplot.png"
        ],
  
    "DAP15_vs_DAP18": 
        
         [
            "/api/static/expression/enrich/DAP15_vs_DAP18_KEGG_barplot.png"
        ],
  
    "DAP15_vs_DAP21": 
        
         [
            "/api/static/expression/enrich/DAP15_vs_DAP21_KEGG_barplot.png"
        ],
  
    "DAP15_vs_DAP24": 
        
         [
            "/api/static/expression/enrich/DAP15_vs_DAP24_KEGG_barplot.png"
        ],
  
    "DAP18_vs_DAP21": 
        
         [
            "/api/static/expression/enrich/DAP18_vs_DAP21_KEGG_barplot.png"
        ],
  
    "DAP18_vs_DAP24": 
        
         [
            "/api/static/expression/enrich/DAP18_vs_DAP24_KEGG_barplot.png"
        ],
  
    "DAP21_vs_DAP24": 
        
         [
            "/api/static/expression/enrich/DAP21_vs_DAP24_KEGG_barplot.png"
        ],
  
    "DAP6_vs_DAP12": 
        
         [
            "/api/static/expression/enrich/DAP6_vs_DAP12_KEGG_barplot.png"
        ],
  
    "DAP6_vs_DAP15": 
        
         [
            "/api/static/expression/enrich/DAP6_vs_DAP15_KEGG_barplot.png"
        ],
  
    "DAP6_vs_DAP18": 
        
         [
            "/api/static/expression/enrich/DAP6_vs_DAP18_KEGG_barplot.png"
        ],
  
    "DAP6_vs_DAP21": 
        
         [
            "/api/static/expression/enrich/DAP6_vs_DAP21_KEGG_barplot.png"
        ],
  
    "DAP6_vs_DAP24": 
        
         [
            "/api/static/expression/enrich/DAP6_vs_DAP24_KEGG_barplot.png"
        ],
  
    "DAP6_vs_DAP9": 
        
         [
            "/api/static/expression/enrich/DAP6_vs_DAP9_KEGG_barplot.png"
        ],
  
    "DAP9_vs_DAP12": 
        
         [
            "/api/static/expression/enrich/DAP9_vs_DAP12_KEGG_barplot.png"
        ],
  
    "DAP9_vs_DAP15": 
        
         [
            "/api/static/expression/enrich/DAP9_vs_DAP15_KEGG_barplot.png"
        ],
  
    "DAP9_vs_DAP18": 
        
         [
            "/api/static/expression/enrich/DAP9_vs_DAP18_KEGG_barplot.png"
        ],
  
    "DAP9_vs_DAP21": 
        
         [
            "/api/static/expression/enrich/DAP9_vs_DAP21_KEGG_barplot.png"
        ],
  
    "DAP9_vs_DAP24": 
        
         [
            "/api/static/expression/enrich/DAP9_vs_DAP24_KEGG_barplot.png"
        ],
  
    "JNP12DAP_vs_JNP15DAP": 
        
         [
            "/api/static/expression/enrich/JNP12DAP_vs_JNP15DAP_KEGG_barplot.png"
        ],
  
    "JNP12DAP_vs_JNP18DAP": 
        
         [
            "/api/static/expression/enrich/JNP12DAP_vs_JNP18DAP_KEGG_barplot.png"
        ],
  
    "JNP12DAP_vs_JNP24DAP": 
        
         [
            "/api/static/expression/enrich/JNP12DAP_vs_JNP24DAP_KEGG_barplot.png"
        ],
  
    "JNP15DAP_vs_JNP18DAP": 
        
         [
            "/api/static/expression/enrich/JNP15DAP_vs_JNP18DAP_KEGG_barplot.png"
        ],
  
    "JNP15DAP_vs_JNP24DAP": 
        
         [
            "/api/static/expression/enrich/JNP15DAP_vs_JNP24DAP_KEGG_barplot.png"
        ],
  
    "JNP18DAP_vs_JNP24DAP": 
        
         [
            "/api/static/expression/enrich/JNP18DAP_vs_JNP24DAP_KEGG_barplot.png"
        ],
  
    "JNP9DAP_vs_JNP12DAP": 
        
         [
            "/api/static/expression/enrich/JNP9DAP_vs_JNP12DAP_KEGG_barplot.png"
        ],
  
    "JNP9DAP_vs_JNP15DAP": 
        
         [
            "/api/static/expression/enrich/JNP9DAP_vs_JNP15DAP_KEGG_barplot.png"
        ],
  
    "JNP9DAP_vs_JNP18DAP": 
        
         [
            "/api/static/expression/enrich/JNP9DAP_vs_JNP18DAP_KEGG_barplot.png"
        ],
  
    "JNP9DAP_vs_JNP24DAP": 
        
         [
            "/api/static/expression/enrich/JNP9DAP_vs_JNP24DAP_KEGG_barplot.png"
        ],
  
    "ZY12DAP_vs_CA12DAP": 
        
         [
            "/api/static/expression/enrich/ZY12DAP_vs_CA12DAP_KEGG_barplot.png"
        ],
  
    "ZY12DAP_vs_ZY9DAP": 
        
         [
            "/api/static/expression/enrich/ZY12DAP_vs_ZY9DAP_KEGG_barplot.png"
        ],
  
    "ZY15DAP_vs_CA15DAP": 
        
         [
            "/api/static/expression/enrich/ZY15DAP_vs_CA15DAP_KEGG_barplot.png"
        ],
  
    "ZY15DAP_vs_ZY12DAP": 
        
         [
            "/api/static/expression/enrich/ZY15DAP_vs_ZY12DAP_KEGG_barplot.png"
        ],
  
    "ZY15DAP_vs_ZY9DAP": 
        
         [
            "/api/static/expression/enrich/ZY15DAP_vs_ZY9DAP_KEGG_barplot.png"
        ],
  
    "ZY9DAP_vs_CA9DAP": 
        
         [
            "/api/static/expression/enrich/ZY9DAP_vs_CA9DAP_KEGG_barplot.png"
        ],
 
};
export default trans_enrich_path_kegg;